module.exports = __webpack_public_path__ + "public/images/travel.a908da3a086968d50a0be727831b0c26.jpg";